import { Component, OnInit } from '@angular/core';
import { Course } from 'src/app/models/course.model';

@Component({
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.scss']
})
export class CourseListComponent implements OnInit {
  course!:Course
  currentIndex = -1

  ngOnInit(): void {
    this.course = history.state.course
  }

  setCurrentIndex(index: number) {
    if (this.currentIndex == index) {
      this.currentIndex = -1
      return
    }
    this.currentIndex = index
  }
}
